var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"card"},[_c('main-tittle',{ref:"mainTittle",attrs:{"topTittle":"湖北财经发展研究报告","subTittle":"导读"}}),_c('div',{staticClass:"commonCartWrap"}),_c('main-foot',{ref:"mainFoot"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }